import { createSlice } from "@reduxjs/toolkit";
import {
  GovernanceData,
  GovernanceInitialStatus,
} from "../../../../../types/webCms/aboutUs/governance";
import {
  getAllGovernanceAsync,
  updateGovernanceAsync,
} from "./becomePartnerApi";

const initialState: GovernanceInitialStatus<GovernanceData> = {
  loading: false,
  manageLoading: false,
  governanceDataList: [],
  countGovernanceData: 0,
};

const governanceSlice = createSlice({
  name: "admin-Governance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllGovernanceAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllGovernanceAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.governanceDataList = action.payload.data;
        state.countGovernanceData = action.payload.length;
      })
      .addCase(getAllGovernanceAsync.rejected, (state) => {
        state.loading = false;
        state.governanceDataList = [];
        state.countGovernanceData = 0;
      });

    // update
    builder
      .addCase(updateGovernanceAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateGovernanceAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateGovernanceAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default governanceSlice;
